'use client';

import { ButtonLink } from './ButtonLink';
import { useChat } from 'react-live-chat-loader';
import { useForwardSearchParams } from '../../utils/useForwardSearchParams';
import { useTranslations } from 'next-intl';
import { AE_PRICING_LINK_ABSOLUTE } from './constants';
import styles from './BottomOverlayAE.module.css';

export const BottomOverlayAE = () => {
  const t = useTranslations('common');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, loadChat] = useChat();
  const forwardSearchParams = useForwardSearchParams();

  return (
    <div className={styles.container}>
      <div className={styles.column}>
        <ButtonLink
          href={forwardSearchParams(AE_PRICING_LINK_ABSOLUTE)}
          rel="noopener noreferrer"
          size="m"
          className={styles.button}
        >
          {t('bottomOverlayAE.buttonLink.buyNow')}
        </ButtonLink>
      </div>
    </div>
  );
};
